import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, ThemeProvider } from '@material-ui/core';

import { useActivation } from '../ActivationContext';

import sleepioTheme from '@/themes/sleepioTheme';
import MagicLinkSent from '@/pages/Onboarding/components/MagicLinkSent/MagicLinkSent';
import { SleepioHeader } from '@/pages/Onboarding/components/Header/SleepioHeader';
import { Footer } from '@/pages/Onboarding/components/Footer/Footer';
import { ConsentWidget } from '@/pages/Onboarding/components/ConsentWidget/ConsentWidget';
import { activateEmail } from '@/utils/sparkActivationApi';
import { getLob } from '@/utils/productHelpers';
import SleepioThumbsUp from '@/assets/SleepioThumbsUp.svg';

const EmailSentInner: React.FC = () => {
  const { t } = useTranslation();
  const { state, dispatch } = useActivation();

  useEffect(() => {
    dispatch({ type: 'SET_STEP', step: 'magic_link_sent' });
  }, [dispatch]);

  const handleResend = async (email: string) => {
    try {
      await activateEmail({
        email,
        product: 'sleepio',
        organizationSlug: state.orgSlug,
        lob: getLob(state.orgSlug),
      });
      return { success: true };
    } catch {
      return { success: false };
    }
  };

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <SleepioHeader />
      <Container maxWidth="xs" style={{ flex: 1 }}>
        <MagicLinkSent
          imageSrc={SleepioThumbsUp}
          imageAlt="Sleepio Thumbs Up"
          title={t('coverage.pre_onboarding.sleepio.activation.email_sent.title')}
          description={t('coverage.pre_onboarding.sleepio.activation.email_sent.description')}
          cantFindTitle={t('coverage.pre_onboarding.sleepio.activation.email_sent.cant_find_title')}
          cantFindDescription={t('coverage.pre_onboarding.sleepio.activation.email_sent.cant_find_description')}
          email={state.email || ''}
          onResend={handleResend}
          buttonLabel={t('coverage.pre_onboarding.sleepio.activation.email_sent.resend')}
        />
        <ConsentWidget />
      </Container>
      <Footer />
    </Box>
  );
};

export const EmailSent: React.FC = () => (
  <ThemeProvider theme={sleepioTheme}>
    <EmailSentInner />
  </ThemeProvider>
);
